import { PayloadAction, createReducer } from "@reduxjs/toolkit";
import { SignalRAction } from "redux/actions";
import InprocessSignalRService from "signalr/InprocessCheckSignalRService";

interface ISignalRState {
  instance?: InprocessSignalRService;
}

const initialState: ISignalRState = {};

const SignalRReducer = createReducer<ISignalRState>(initialState, (builder) => {
  builder.addCase(
    SignalRAction.initInstance.request,
    (state, action: PayloadAction<string>) => {
      state.instance = new InprocessSignalRService(action.payload);
    }
  );
});

export default SignalRReducer;
